/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3Region } from '../models/V3Region';
import { HttpFile } from '../http/http';

export class V3ListXandrRegionsResponse {
    'regions'?: Array<V3Region>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<V3Region>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3ListXandrRegionsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

